import React, { Component } from "react";
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';

import "bootstrap/dist/css/bootstrap.css";

//import SliderCard from "./SliderCard";
import Slider  from "./SliderNew";
import HomeCardDeck from "./HomeCardDeck";
import AboutModal from "./AboutModal";
import pagecontent from "./HomePagePopupContent";
import Observations from "./Observations";
import HydrologyCarousel from "./HydrologyCarousel"
import background from "../images/background.png"
import Bulletin from "./Bulletin";
import SliderProducts from "./SliderProducts";
//import FooterNew from "../FooterNew";
import { connect } from "react-redux";
import { displayAboutModal } from "./redux_components/actions/CommonActions";
import FooterNew from "../FooterNew"
import UserStatistics from "./UserStatistic";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Suspense } from 'react';

//const HydrologyCarousel = React.lazy(() => import('./HydrologyCarousel'));

class Home extends Component {   
  render() {
    return (
        <>

    <Container fluid> 
      <Row>
        <Col >
              <Slider />
          </Col>
        
      </Row>
      <Row>
      <Col >
          <Container fluid >
          <SliderProducts/> 
          </Container>
         
          </Col>
      </Row>
      <Row>
        <Col >
            <Container>
            <div className="Observations">
            <Observations /></div>
            </Container>
          </Col>
        
      </Row>
      <Row>
      <Col >    
            <Container fluid>
            <div className="HydrologyCarousel" >

            <Suspense fallback={<div>Loading...</div>}>
            <HydrologyCarousel />
      </Suspense>
           
            </div>
            </Container>
          </Col>
      </Row>
      <Row>
        <Col >
     
            <Container fluid>
            <div className="Bulletin" >
            <Bulletin/>
            </div>
            </Container>
           
       </Col>
        
      </Row>
      <Row>
      <Col >     
          <Container fluid>
          <div className="UserStatistics" >
            <UserStatistics/>
            </div>
            </Container>
            
          </Col>
      </Row>
      <Row>
        <Col >  
      <FooterNew/>
</Col>  
      </Row>
 
    </Container>
    </>
    );
  }
}
const mapStateToProps = (state) => {
    return {
      modal: state.CState.modal,
    };
  };
  export default connect(mapStateToProps, { displayAboutModal })(Home);
                                            
      